import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Spinner } from './components/ui';
import { useSession } from './lib/session';
import { AlarmsPage } from './pages/Alarms';
import { AuditPage } from './pages/Audit';
import { BackupDriveCallbackPage } from './pages/BackupDriveCallback';
import { BackupsPage } from './pages/Backups';
import { ConversionsPage } from './pages/Conversions';
import { WithdrawalsPage } from './pages/Withdrawals';
import { DashboardPage } from './pages/Dashboard';
import { EconomyPage } from './pages/Economy';
import { LoginPage } from './pages/Login';
import { NotificationsPage } from './pages/Notifications';
import { ReferralsPage } from './pages/Referrals';
import { UsersPage } from './pages/Users';

export function App() {
  const session = useSession();

  if (session.isPending) {
    return (
      <div className="grid min-h-dvh place-items-center bg-canvas">
        <Spinner className="size-6" />
      </div>
    );
  }

  // No redirect on sign-out: rendering the login screen in place keeps the
  // requested URL intact, so a deep link survives a login.
  if (!session.data) return <LoginPage />;

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout session={session.data} />}>
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="alarms" element={<AlarmsPage />} />
          {/* Events are read under the alarm that produced them now. The
              redirect keeps old bookmarks — and the review queue's own url —
              pointing somewhere real. */}
          <Route
            path="events"
            element={<Navigate to="/alarms?tab=review" replace />}
          />
          <Route path="economy" element={<EconomyPage />} />
          <Route path="withdrawals" element={<WithdrawalsPage />} />
          <Route path="conversions" element={<ConversionsPage />} />
          <Route path="referrals" element={<ReferralsPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="backups" element={<BackupsPage />} />
          {/* Google's consent screen returns here (BACKUP_GOOGLE_REDIRECT_URI). */}
          <Route
            path="backups/drive/callback"
            element={<BackupDriveCallbackPage />}
          />
          <Route path="*" element={<DashboardPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
